import { render, staticRenderFns } from "./baomingLog.vue?vue&type=template&id=1bc7a807&"
import script from "./baomingLog.vue?vue&type=script&lang=js&"
export * from "./baomingLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports